import { StyledGraphHeader } from '../../ResourceAllocationOverview.style';
import ResourceTypeDropDown from './ResourceTypeDropDown';

const FteHeader = ({ resourceType, setResourceType }) => {
  return (
    <StyledGraphHeader>
      FTE Allocation By
      <ResourceTypeDropDown
        resourceType={resourceType}
        onChange={resourceType => setResourceType(resourceType)}
      />
    </StyledGraphHeader>
  );
};

export default FteHeader;
